import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'customDatePipe',
  standalone: true
})
export class CustomDatePipe implements PipeTransform {

  transform(timestamp: string | Date | number, format: string = 'MM/DD/YYYY', timeFormat: number = 24): string {
    if (!timestamp) return '-'; // Return an empty string if the timestamp is null or invalid

    if (timestamp === '-') return '-'; // Return an '-' if the timestamp is null or invalid

    if (typeof timestamp === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+$/.test(timestamp)) {
      // Trim high-precision fractional seconds (retain up to milliseconds)
      const trimmedTimestamp = timestamp.replace(/\.\d+$/, '');
  
      const date = new Date(`${trimmedTimestamp}Z`); // Append 'Z' to treat as UTC and convert to local time
  
      // Get local date components
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
  
      // Get local time components
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
  

      if(timeFormat === 12) {

        let hours = date.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12; // Convert 24-hour format to 12-hour format
        hours = hours || 12; // If `hours` is 0 (midnight), make it 12

        return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
      }

      // Return the formatted date and time
      return `${month}/${day}/${year} ${hours}:${minutes}`;
    } 
    
    const date = new Date(timestamp); // Create a Date object using the timestamp    

    // Extract date components using local time
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const year = date.getFullYear();

    if (format === 'MM-DD-YYYY') {
      return `${month}-${day}-${year}`;
    };

    // If the format is only for the date (MM/DD/YYYY), return it
    if (format === 'MM/DD/YYYY') {
      return `${month}/${day}/${year}`;
    }

    // Extract time components if time formatting is required
    let hours = date.getHours(); // Get hours in 24-hour format
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Ensure two digits for minutes

    if(timeFormat == 24) {
      return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes}`;
    }

    // Determine AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; // Convert 24-hour format to 12-hour format
    hours = hours || 12; // If `hours` is 0 (midnight), make it 12

    // Combine date and time components into the desired format: MM/DD/YYYY HH:MM AM/PM
    if (format === 'MM/DD/YYYY HH:MM') {
      return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
    }

    // Return an empty string if an unknown format is passed
    return '';
  }
}
